module.exports = __webpack_public_path__ + "static/media/practice_test.1dd2214a.png";